import { STORE_ENUM } from "@/store/store.enums";
import AdminPanelService from "@/services/admin-panel.service";

export default {
  state: {
    adminMenuItems: [],
    caseStatuses: [],
    charityRequests: [],
    wallets: [],
    financialOperations: [],
    treatmentRequests: [],
    supportTicketSubMenuItems: [],
    usersReportSidebar: [],
    casesReportSidebar: [],
    donationsReportSidebar: [],
    reportsNestedSubItems: [],
    userRole:'',
    // The stable, never-translated role key. Left undefined when the backend
    // does not send the field at all (older deployments), which is NOT the
    // same as an explicit null meaning "this user has no active role".
    userRoleKey: undefined as string | null | undefined
  },
  getters: {},
  actions: {
    [STORE_ENUM.MENU_ITEMS]({ commit }: any) {
      return new Promise((resolve, reject) => {
        AdminPanelService.getUserMenuItems()
          .then(({ data }) => {
            const { result, admin_name, active_role, user_has_multiple_roles } = data;
            // Read off `data` rather than destructuring, so an absent field
            // stays `undefined` and is distinguishable from an explicit null.
            const active_role_key = data.active_role_key;

            commit(STORE_ENUM.MENU_ITEMS, {result, active_role, active_role_key});

            resolve({ admin_name, active_role, active_role_key, user_has_multiple_roles });
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    [STORE_ENUM.CASE_STATUSES]({ commit }: any) {
      return new Promise((resolve, reject) => {
        AdminPanelService.getAdminMenu()
          .then(({ data: { result } }) => {
            commit(STORE_ENUM.CASE_STATUSES, result);

            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    [STORE_ENUM.CHARITY_REQUESTS]({ commit }: any) {
      return new Promise((resolve, reject) => {
        AdminPanelService.getCharityRequestsSubMenu()
          .then(({ data: { result } }) => {
            commit(STORE_ENUM.CHARITY_REQUESTS, result);

            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    [STORE_ENUM.WALLETS]({ commit }: any) {
      return new Promise((resolve, reject) => {
        AdminPanelService.getWalletsSubMenu()
          .then(({ data: { result } }) => {
            commit(STORE_ENUM.WALLETS, result);

            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    [STORE_ENUM.FINANCIAL_OPERATIONS]({ commit }: any) {
      return new Promise((resolve, reject) => {
        AdminPanelService.getFinancialOperationsSubMenu()
          .then(({ data: { result } }) => {
            commit(STORE_ENUM.FINANCIAL_OPERATIONS, result);

            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    [STORE_ENUM.TREATMENT_REQUESTS]({ commit }: any) {
     return new Promise((resolve, reject) => {
        AdminPanelService.getTreatmentRequestsSubMenu()
          .then(({ data: { result } }) => {
            commit(STORE_ENUM.TREATMENT_REQUESTS, result);
            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
     });
    },
    [STORE_ENUM.SUPPORT_TICKETS]({ commit }: any) {
      return new Promise((resolve, reject) => {
        AdminPanelService.getSupportTicketsSubMenu()
          .then(({ data: { result } }) => {
            commit(STORE_ENUM.SUPPORT_TICKETS, result);

            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
     });
    },
    [STORE_ENUM.USERS_REPORT_SIDEBAR]({ commit }: any) {
      return new Promise((resolve, reject) => {
        AdminPanelService.getUsersReportSidebar()
          .then(({ data: { result } }) => {
            commit(STORE_ENUM.USERS_REPORT_SIDEBAR, result);

            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    [STORE_ENUM.CASES_REPORT_SIDEBAR]({ commit }: any) {
      return new Promise((resolve, reject) => {
        AdminPanelService.getCasesReportSidebar()
          .then(({ data: { result } }) => {
            commit(STORE_ENUM.CASES_REPORT_SIDEBAR, result);

            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    [STORE_ENUM.DONATIONS_REPORT_SIDEBAR]({ commit }: any) {
      return new Promise((resolve, reject) => {
        AdminPanelService.getDonationsReportSidebar()
          .then(({ data: { result } }) => {
            commit(STORE_ENUM.DONATIONS_REPORT_SIDEBAR, result);

            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    [STORE_ENUM.REPORTS_NESTED_SUB_ITEMS]({ commit }: any) {
      return new Promise((resolve, reject) => {
        AdminPanelService.getNestedReportSidebar()
          .then(({ data: { result } }) => {
            commit(STORE_ENUM.REPORTS_NESTED_SUB_ITEMS, result);

            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  },
  mutations: {
    [STORE_ENUM.MENU_ITEMS](state: any, {result, active_role, active_role_key}: any) {
      state.adminMenuItems = result;
      state.userRole = active_role;
      state.userRoleKey = active_role_key;
    },
    [STORE_ENUM.CASE_STATUSES](state: any, result: any) {
      state.caseStatuses = result;
      // @ts-ignore
      state.adminMenuItems.find(item => item.id === 1)?.sub_items = state.caseStatuses;
    },
    [STORE_ENUM.CHARITY_REQUESTS](state: any, result: any) {
      state.charityRequests = result;
      // @ts-ignore
      state.adminMenuItems.find(item => item.id === 100)?.sub_items = state.charityRequests;
    },
    [STORE_ENUM.WALLETS](state: any, result: any) {
      state.wallets = result;
      // @ts-ignore
      state.adminMenuItems.find(item => item.id === 101)?.sub_items = state.wallets;
    },
    [STORE_ENUM.FINANCIAL_OPERATIONS](state: any, result: any) {
      state.financialOperations = result;
      // @ts-ignore
      state.adminMenuItems.find(item => item.id === 102)?.sub_items = state.financialOperations;
    },
    [STORE_ENUM.TREATMENT_REQUESTS](state: any, result: any) {
      state.treatmentRequests = result;
      // @ts-ignore
      state.adminMenuItems.find(item => item.id === 199)?.sub_items = state.treatmentRequests;
    },
    [STORE_ENUM.SUPPORT_TICKETS](state: any, result: any) {
      state.supportTicketSubMenuItems = result;
      // @ts-ignore
      state.adminMenuItems.find(item => item.id === 99)?.sub_items = state.supportTicketSubMenuItems;
    },
    [STORE_ENUM.USERS_REPORT_SIDEBAR](state: any, result: any) {
      state.usersReportSidebar = result;
      // @ts-ignore
      state.adminMenuItems.find(item => item.id === 140)?.sub_items = state.usersReportSidebar;
    },
    [STORE_ENUM.CASES_REPORT_SIDEBAR](state: any, result: any) {
      state.casesReportSidebar = result;
      // @ts-ignore
      state.adminMenuItems.find(item => item.id === 141)?.sub_items = state.casesReportSidebar;
    },
    [STORE_ENUM.DONATIONS_REPORT_SIDEBAR](state: any, result: any) {
      state.donationsReportSidebar = result;
      // @ts-ignore
      state.adminMenuItems.find(item => item.id === 142)?.sub_items = state.donationsReportSidebar;
    },
    [STORE_ENUM.REPORTS_NESTED_SUB_ITEMS](state: any, result: any) {
      const nestedSubItems = result;

      if (Array.isArray(nestedSubItems)) {
        nestedSubItems.forEach((item: any) => {
          item.isCollapsed = true;
        });
      }
      
      state.reportsNestedSubItems = nestedSubItems;
      // @ts-ignore
      state.adminMenuItems.find(item => item.id === 140)?.sub_items = state.reportsNestedSubItems;
    },

    CHANGE_COUNT(state: any, payload: { status: string, payment_request_check: boolean }) {
      const { status, payment_request_check = false} = payload;
      // if payment_request_check = true then menuItems does not include subitems
      const menuItems = payment_request_check ? state.adminMenuItems : state.adminMenuItems[0]?.sub_items
      // if the data is not coming from payment request then change data in subitems of menuItems
      if (!payment_request_check){
          const index = menuItems?.findIndex((e: any) => e.name === status)
          if (index != -1  && index >=0 && menuItems[index]?.count) {
            state.adminMenuItems[0].sub_items[index].count = menuItems[index].count - 1
          }
      }
      // if the data is coming from payment request then change menu items only
      else {
          const index = menuItems.findIndex((e: any) => e.name === status)
          if (index != -1  && index >=0 && menuItems[index]?.counter) {
            state.adminMenuItems[index].counter = menuItems[index].counter - 1
          }
      }
    }
  },
}
